export const PROVIDER_LIST_CONTAINER = 'provider-list';

/** Width from which a provider row lays its name, activity and address out in columns. */
export const PROVIDER_LIST_WIDE_MIN_WIDTH = 720;

export const PROVIDER_LIST_WIDE_QUERY = `@container ${PROVIDER_LIST_CONTAINER} (min-width: ${PROVIDER_LIST_WIDE_MIN_WIDTH}px)`;

export const PROVIDER_TILE_SIZE = 40;
export const PROVIDER_TILE_SIZE_WIDE = 32;
